<ng-container></ng-container>
<div class="main" *ngIf="isOnDemandTrainingEducationToggleOn">
  <div>
    <h3
      class="header"
      data-test-id="onDemandTrainingWelcome"
      attr.aria-label="{{ 'broker.onDemandTraining.welcome' | translate }}"
    >
      {{ 'broker.onDemandTraining.welcome' | translate }}
    </h3>
    <div
      class="sub-header"
      data-test-id="onDemandTrainingWelcomeHeader"
      attr.aria-label="{{
        'broker.onDemandTraining.welcomeHeader' | translate
      }}"
    >
      {{ 'broker.onDemandTraining.welcomeHeader' | translate }}
    </div>

    <span
      class="stay-informed-on-the"
      data-test-id="onDemandTrainingWelcomeContent"
      attr.aria-label="{{
        'broker.onDemandTraining.welcomeContent' | translate
      }}"
    >
      {{ 'broker.onDemandTraining.welcomeContent' | translate }}
    </span>
  </div>
  <div class="content">
    <div class="training-center-img"></div>
  </div>
</div>
<div class="training-container">
  <div class="training-container-box">
    <cigna-ondemand-training *ngIf="isOnDemandTrainingEducationToggleOn">
    </cigna-ondemand-training>
  </div>
  <div class="training-container-box">
    <cigna-continuing-education *ngIf="isOnDemandTrainingEducationToggleOn">
    </cigna-continuing-education>
  </div>
</div>
